import { Route } from '@angular/router';
import { FeatureRouteAccessService } from '../core/auth/feature-route-access-service';
import { FeaturesEnum } from '../shared/constants/features.constants';

import { HomeComponent } from './home.component';

export const HOME_ROUTE: Route = {
  path: 'home',
  component: HomeComponent,
  data: {
    authorities: [],
    featureId: FeaturesEnum.HOME,
    pageTitle: 'home.title',
  },
  canActivate: [FeatureRouteAccessService],
};
